import Tooltip from "@material-ui/core/Tooltip";

import CellContainerRow from "./CellContainerRow";
import CellFirstRow from "./CellFirstRow";
import CellSecondRow from "./CellSecondRow";
import CellEmptyRow from "./CellEmptyRow";
import TripAlertTooltip from "app/main/profile/trips/TripAlertTooltip";
import { formatDate } from "app/main/utils/dateUtils";
import { getAlertLabel, getHosDisplayConfig, getStopArrivalFaceConfig } from "app/main/utils/uiUtils";

function AlertCellView(props) {
	const mobile = props.mobile;
	const variant = props.variant;
	const config = props.config;
	const item = props.item;
	const view = props.view;

	if (!view) {
		return <CellEmptyRow mobile={mobile} variant={variant} />;
	}

	const { stopArrivalStatus, currentETA, currentETD, hosStatus, hosEstimate } = view;
	const label = getAlertLabel(stopArrivalStatus, hosStatus);
	const faceConfig = getStopArrivalFaceConfig(stopArrivalStatus, hosStatus);
	const FaceIcon = faceConfig.Icon;
	const hosDisplay = getHosDisplayConfig(hosStatus);
	const trimbleUrl = config?.getTrimbleUrl?.(item) ?? item?.data?.trimble_url;

	const etaLabel = currentETA ? `ETA ${formatDate(currentETA, null, true)}` : null;

	const tooltipContent = (
		<TripAlertTooltip
			stopArrivalStatus={stopArrivalStatus}
			currentETA={currentETA}
			currentETD={currentETD}
			hosStatus={hosStatus}
			hosEstimate={hosEstimate}
		/>
	);

	const cellContent = (
		<CellContainerRow
			mobile={mobile}
			variant={variant}
			left={<FaceIcon className={"text-20 mr-8 flex-shrink-0 " + faceConfig.iconClass} />}
			first={
				<CellFirstRow mobile={mobile} label={label} variant={variant} color={faceConfig.iconClass + " font-semibold"} />
			}
			second={
				<div className="flex flex-row items-center flex-wrap">
					{etaLabel && <CellSecondRow mobile={mobile} label={etaLabel} variant={variant} />}
					{hosDisplay && (
						<CellSecondRow
							mobile={mobile}
							icon={hosDisplay.icon}
							label={hosDisplay.label}
							variant={variant}
							color={hosDisplay.color}
							classes={{ icon: hosDisplay.iconClass, label: hosDisplay.color }}
						/>
					)}
				</div>
			}
		/>
	);

	const wrappedCell = trimbleUrl ? (
		<div
			className="cursor-pointer"
			onClick={(e) => {
				e.stopPropagation();
				window.open(trimbleUrl, "_blank");
			}}
		>
			{cellContent}
		</div>
	) : (
		cellContent
	);

	return (
		<Tooltip
			title={tooltipContent}
			placement="right"
			arrow
			interactive
			classes={{ tooltip: "p-0 bg-white text-primary shadow-lg border border-grey-300" }}
		>
			<div>{wrappedCell}</div>
		</Tooltip>
	);
}

export default AlertCellView;
